// Frontend mirror of backend Pro gating (backend entitlements.py is the
// enforcement source of truth; this drives UX — badges, locks, interception).

// Catalog keys that require Pro to RUN (Multi-Environment AMMI/GGE/MET family
// + Path Analysis). Molecular/QTL, Polyploid & BK Intelligence are whole pages
// gated via <ProGate/> instead.
export const PRO_ANALYSIS_KEYS = new Set([
  'eberhart', 'comp-stability', 'ammi', 'gge', 'met',
  'pooled-anova', 'full-met', 'augmented-met', 'genotype-year',
  'path',
]);

export function isProUser(user) {
  return !!user && (user.plan === 'pro' || user.role === 'admin');
}

export function isProAnalysis(key) {
  return PRO_ANALYSIS_KEYS.has(key);
}
